<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-none element-with-heading" id="part-1-uncategorized">
<div class="heading heading-with-title heading-without-image" id="part-1-uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Help Wanted (part-time work, full-time hours)</h1>
</div>
</div>
</div>
</div>
<div class="text" id="part-1-uncategorized-text">
<p class="first first-in-chapter first-full-width"><i>Seeking middle-aged applicants who are already employed (including: accountants, attorneys, dentists, educators, firefighters, police officers, sales representatives, business owners, and executives) to supervise organized violence on Sundays, occasional weeknights and holidays. Must be able to take unlimited criticism with little to no praise. Possibility of injury.</i></p>
<p class="subsq"><i>Requirements: high level of intelligence, physical fitness, and extraordinary mental focus while absorbing crude verbal abuse. Some positions require the ability to keep up with men who can cover forty yards in 4.3 seconds. Requires knowledge of highly complex rules to be applied instantly and instinctively in front of huge audiences. Involves making split-second decisions that affect lives and fortunes.</i></p>
<p class="subsq"><i>The successful candidate should be able to devote in excess of forty hours per week with the expectation that the applicant already has a full-time job. Ten years of college-game or other high-level experience required.</i></p>
<p class="subsq"><i>If interested, apply to the National Football League, Attention: Department of Officiating.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001helpwantedparttimeworkfulltimehours.vue?51a436fa